import React, { useState } from "react";
import { Collapse } from "reactstrap";

const AccordianContentRight = () => {
    //Collapse Tab

    const [isCollapseFourth, setIsCollapseFourth] = useState(true);
    const toggleFourth = () => setIsCollapseFourth(!isCollapseFourth);

    const [isCollapseFifth, setIsCollapseFifth] = useState(false);
    const toggleFifth = () => setIsCollapseFifth(!isCollapseFifth);

    const [isCollapseSixth, setIsCollapseSixth] = useState(false);
    const toggleSixth = () => setIsCollapseSixth(!isCollapseSixth);

    const [isCollapseSeventh, setIsCollapseSeventh] = useState(false);
    const toggleSeventh = () => setIsCollapseSeventh(!isCollapseSeventh);
    return (
        <React.Fragment>
            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="generalfour">
                    <button
                        className="accordion-button"
                        onClick={toggleFourth}
                        type="button"
                    >
                        How do I edit or delete a job posting?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseFourth} id="general-four">
                    <div className="accordion-body">
                        Go to your employer dashboard, find the job listing you want to edit or delete, and use the respective options to update or remove it.
                    </div>
                </Collapse>
            </div>

            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="generalfive">
                    <button
                        className="accordion-button"
                        onClick={toggleFifth}
                        type="button"
                    >
                        Is there a fee to post jobs?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseFifth} id="general-five">
                    <div className="accordion-body">
                        Basic job postings are free, but we offer premium plans with extra features like highlighted listings and priority placement.
                    </div>
                </Collapse>
            </div>

            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="generalsix">
                    <button
                        className="accordion-button"
                        onClick={toggleSixth}
                        type="button"
                    >
                        How do I track my job applications?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseSixth} id="general-six">
                    <div className="accordion-body">
                        Job seekers can track their applications through their profile dashboard under the "My Applications" section.
                    </div>
                </Collapse>
            </div>

            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="generalseven">
                    <button
                        className="accordion-button"
                        onClick={toggleSeventh}
                        type="button"
                    >
                        What should I do if I forget my password?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseSeventh} id="general-seven">
                    <div className="accordion-body">
                        Click on the "Forgot Password" link on the login page and follow the instructions to reset your password.
                    </div>
                </Collapse>
            </div>
        </React.Fragment>
    );
};

export default AccordianContentRight;
